import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { CSVLink } from "react-csv";

const headers = [
  { label: "User Name", key: "user_name_display" },
  { label: "User Image", key: "user_avatar" },
  { label: "User Points", key: "points" },
  { label: "User Rank", key: "user_rank" },
];

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayDate = yesterday.toISOString().slice(0, 10);
    this.state = {
      items: [],
      filterDate: "",
      date1: yesterdayDate,
      status: "Active",
    };
    this.voterList = this.voterList.bind(this);
  }
  componentDidMount() {
    this.voterList();
  }

  ondateChangeHandler = (e) => {
    this.setState({
      filterDate: e.target.value,
    });
    $("#loader").css({ display: "block" });
    this.voterList(e.target.value);
    $("#loader").css({ display: "none" });
  };

  voterList = (date) => {
    $("#loader").css({ display: "block" });
    var ref = this;
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `https://dwltnlb3hto3i.cloudfront.net/v1/report/daily?date=${
        date ? date : this.state.date1
      }`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          result["resultFlag"] == "1" &&
          result["resultFlag"] == 1
        ) {
          ref.setState(
            {
              items: result.response,
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      })
      .catch((error) => console.log("error", error));
  };

  render() {
    var bread = "Vocal For Local / Dashboard";
    var items = this.state.items;
    var type = this.state.type;
    return (
      <div>
        <PageTitle
          title="#Vocal For Local"
          bread={bread}
          Count={this.state.post_count}
        />
        <div className="wrapper wrapper-content">
          <div
            className="form-inline form_right"
            style={{ top: "0px", right: "34px" }}
          >
            <div style={{ "padding-right": "710px" }}>
              <input
                className="form-control"
                type="date"
                value={
                  this.state.filterDate
                    ? this.state.filterDate
                    : this.state.date1
                }
                max={this.state.date1}
                onChange={(e) => this.ondateChangeHandler(e)}
              />
              <button
                className="btn-success"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Clear filters
              </button>
            </div>
            <div className="row row_date_div">
              <CSVLink
                style={{
                  margin: "0px 0px -6px 30px",
                  right: "0px",
                  position: "absolute",
                }}
                data={items}
                headers={headers}
                filename="Vocalforlocal.csv"
              >
                <img
                  style={{ width: "30px" }}
                  alt="image"
                  src="/img/filetype-csv.svg"
                />
              </CSVLink>
            </div>
          </div>
        </div>
        <hr style={{ margin: "0px", "border-top": "1px solid black" }} />
        <div className="wrapper wrapper-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <table className="table mt-5">
                  <thead className="thead-dark">
                    <tr>
                      <th>User Name</th>
                      <th>User Points</th>
                      <th>User Rank</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(items) &&
                      items.map((value, index) => {
                        return (
                          <tr>
                            <td>
                              {value.user_name_display
                                ? value.user_name_display
                                : "null"}
                            </td>
                            <td>{value.points ? value.points : "0"}</td>
                            <td>{value.user_rank ? value.user_rank : "0"}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/VocalForLocal/Dashboard.jsx